import { ChevronDown } from "lucide-react";

import type { SpendPeriodType } from "@/types/spend";

export const PeriodControls = ({
  periodType,
  year,
  years,
  onPeriodChange,
  onYearChange,
}: {
  periodType: SpendPeriodType;
  year: number;
  years: number[];
  onPeriodChange: (value: SpendPeriodType) => void;
  onYearChange: (value: number) => void;
}) => (
  <div className="flex flex-wrap items-center gap-3" aria-label="Reporting period">
    <fieldset className="flex h-10 rounded-md border border-[#d8cfc5] bg-white p-1">
      <legend className="sr-only">Period type</legend>
      {(["calendar", "fiscal"] as const).map(value => (
        <button
          key={value}
          type="button"
          aria-pressed={periodType === value}
          className={`h-full rounded px-3 text-sm font-semibold ${periodType === value ? "bg-[#111b35] text-white" : "text-gray-600"}`}
          onClick={() => onPeriodChange(value)}
        >
          {value === "calendar" ? "Calendar year" : "Fiscal year"}
        </button>
      ))}
    </fieldset>
    <span className="relative block">
      <select
        aria-label="Year"
        value={year}
        onChange={event => onYearChange(Number(event.target.value))}
        className="block h-10 appearance-none rounded-md border border-[#d8cfc5] bg-white py-0 pl-3 pr-9 text-sm text-gray-800"
      >
        {(years.length ? years : [year]).map(value => (
          <option key={value}>{value}</option>
        ))}
      </select>
      <ChevronDown
        aria-hidden="true"
        className="pointer-events-none absolute right-3 top-1/2 size-4 -translate-y-1/2 text-gray-500"
      />
    </span>
  </div>
);
